(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8769],{

/***/ 38094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92952);
/* harmony import */ var _segment_matcha_components_Typography__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89533);
/* harmony import */ var _segment_matcha_recipes_Section__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88392);
/* harmony import */ var _segment_matcha_recipes_LogoCarousel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74595);
/* harmony import */ var _segment_templates_LogoCarousel_data__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43787);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52903);


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







var copy = {
  heading: "Our virtual summit brings together leaders from:"
};
var logos = [_segment_templates_LogoCarousel_data__WEBPACK_IMPORTED_MODULE_4__/* .carouselLogosMono.DIGITAL_OCEAN */ .G.DIGITAL_OCEAN, _segment_templates_LogoCarousel_data__WEBPACK_IMPORTED_MODULE_4__/* .carouselLogosMono.IBM */ .G.IBM, _segment_templates_LogoCarousel_data__WEBPACK_IMPORTED_MODULE_4__/* .carouselLogosMono.DOMINOS */ .G.DOMINOS, _segment_templates_LogoCarousel_data__WEBPACK_IMPORTED_MODULE_4__/* .carouselLogosMono.ANHEUSER_BUSCH */ .G.ANHEUSER_BUSCH, _segment_templates_LogoCarousel_data__WEBPACK_IMPORTED_MODULE_4__/* .carouselLogosMono.VMWARE */ .G.VMWARE, _segment_templates_LogoCarousel_data__WEBPACK_IMPORTED_MODULE_4__/* .carouselLogosMono.LEVIS */ .G.LEVIS, _segment_templates_LogoCarousel_data__WEBPACK_IMPORTED_MODULE_4__/* .carouselLogosMono.LOG_ME_IN */ .G.LOG_ME_IN, _segment_templates_LogoCarousel_data__WEBPACK_IMPORTED_MODULE_4__/* .carouselLogosMono.CLEAR_SCORE */ .G.CLEAR_SCORE, _segment_templates_LogoCarousel_data__WEBPACK_IMPORTED_MODULE_4__/* .carouselLogosMono.VACASA */ .G.VACASA, _segment_templates_LogoCarousel_data__WEBPACK_IMPORTED_MODULE_4__/* .carouselLogosMono.STAPLES */ .G.STAPLES, _segment_templates_LogoCarousel_data__WEBPACK_IMPORTED_MODULE_4__/* .carouselLogosMono.INTUIT */ .G.INTUIT, _segment_templates_LogoCarousel_data__WEBPACK_IMPORTED_MODULE_4__/* .carouselLogosMono.DRIFT */ .G.DRIFT, _segment_templates_LogoCarousel_data__WEBPACK_IMPORTED_MODULE_4__/* .carouselLogosMono.ALLERGAN */ .G.ALLERGAN, _segment_templates_LogoCarousel_data__WEBPACK_IMPORTED_MODULE_4__/* .carouselLogosMono.GLOSSIER */ .G.GLOSSIER, _segment_templates_LogoCarousel_data__WEBPACK_IMPORTED_MODULE_4__/* .carouselLogosMono.AB_IN_BEV */ .G.AB_IN_BEV];

var CarouselSection = function CarouselSection() {
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_segment_matcha_recipes_Section__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
    variant: "noCopy",
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(SectionContents, {
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Heading, {
        variant: "h4",
        tag: "h2",
        children: copy.heading
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(StyledLogoCarousel, {
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_segment_matcha_recipes_LogoCarousel__WEBPACK_IMPORTED_MODULE_3__/* .LogoTrack */ .xS, {
          icons: logos
        })
      })]
    })
  });
};

var SectionContents = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_segment_matcha_recipes_Section__WEBPACK_IMPORTED_MODULE_2__/* .Contents */ .AU,  true ? {
  target: "e1qxttvx2"
} : 0)("display:grid;text-align:center;row-gap:32px;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("lg");
}, "{row-gap:48px;}" + ( true ? "" : 0));

var StyledLogoCarousel = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_segment_matcha_recipes_LogoCarousel__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP,  true ? {
  target: "e1qxttvx1"
} : 0)( true ? {
  name: "1qzt7iu",
  styles: "row-gap:0;grid-template-rows:24px;padding:0"
} : 0);

var Heading = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_segment_matcha_components_Typography__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,  true ? {
  target: "e1qxttvx0"
} : 0)( true ? {
  name: "15i8qv7",
  styles: "margin:0;display:block"
} : 0);

/* harmony default export */ __webpack_exports__["Z"] = (CarouselSection);

/***/ }),

/***/ 27149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Footer_Footer; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(23769);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../libs/matcha/components/SegmentLogo/index.ts + 2 modules
var SegmentLogo = __webpack_require__(84672);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Footer/index.ts + 4 modules
var Footer = __webpack_require__(80653);
;// CONCATENATED MODULE: ./src/views/CdpWeek2023/components/Footer/data.ts
var data = {
  bottomLinks: [{
    url: "https://www.twilio.com/legal/privacy/",
    title: "Privacy policy"
  }, {
    url: "https://www.twilio.com/legal/tos/",
    title: "Terms of Service"
  }],
  copyright: "\xA9 ".concat(new Date().getUTCFullYear(), " Twilio Inc. All Rights Reserved.")
};
/* harmony default export */ var Footer_data = (data);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/CdpWeek2023/components/Footer/Footer.tsx




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var Footer_Footer = function Footer(_ref) {
  var props = (0,esm_extends/* default */.Z)({}, _ref);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledFooterRecipe, _objectSpread({
    bottomLinks: Footer_data.bottomLinks,
    copyright: Footer_data.copyright,
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
      href: "https://segment.com/",
      passHref: true,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
        alt: "Twilio, Inc."
      })
    })
  }, props));
};

var StyledFooterRecipe = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Footer/* default */.Z,  true ? {
  target: "eij1tmp0"
} : 0)(Footer/* Content */.V, "{max-width:1280px;}" + ( true ? "" : 0));

/* harmony default export */ var components_Footer_Footer = (Footer_Footer);

/***/ }),

/***/ 61983:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Navigation; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Media/index.ts + 2 modules
var Media = __webpack_require__(75091);
// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/Button.tsx
var Button = __webpack_require__(62073);
// EXTERNAL MODULE: ../../libs/matcha/components/SegmentLogo/index.ts + 2 modules
var SegmentLogo = __webpack_require__(84672);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/index.ts + 24 modules
var DesktopNavigation = __webpack_require__(82680);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/Navbar/index.ts + 14 modules
var Navbar = __webpack_require__(77966);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/index.ts + 30 modules
var MobileNavigation = __webpack_require__(86943);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/Navbar/index.ts + 8 modules
var MobileNavigation_Navbar = __webpack_require__(90806);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ./src/views/CdpWeek2023/utils/useDomainPath/useDomainPath.ts
var useDomainPath = __webpack_require__(5565);
;// CONCATENATED MODULE: ./src/views/CdpWeek2023/utils/useNavLinks/useNavLinks.ts


var useNavLinks = function useNavLinks() {
  var aboutLink = (0,useDomainPath/* default */.Z)();
  var agendaLink = (0,useDomainPath/* default */.Z)("agenda");
  var speakersLink = (0,useDomainPath/* default */.Z)("speakers");
  return [{
    id: "about",
    title: "About",
    url: aboutLink || "/about/"
  }, {
    id: "agenda",
    title: "Agenda",
    url: agendaLink
  }, {
    id: "speakers",
    title: "Speakers",
    url: speakersLink
  }];
};

/* harmony default export */ var useNavLinks_useNavLinks = (useNavLinks);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/CdpWeek2023/components/Navigation/Navigation.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }





















var BaseNavigation = function BaseNavigation(_ref) {
  var _ref$aside = _ref.aside,
      aside = _ref$aside === void 0 ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RegisterButton, {}) : _ref$aside;
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();

  var _useState = (0,react.useState)(false),
      isMenuOpen = _useState[0],
      setIsMenuOpen = _useState[1];

  var navLinks = useNavLinks_useNavLinks();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioDark",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Media/* default */.Z, {
      greaterThanOrEqual: "lg",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DesktopNavigation/* default */.ZP, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DesktopNavigation/* Navbar */.wp, {
          tokens: {
            backgroundColor: theme.palette.twilio.gray[100]
          },
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navbar/* Brand */.H2, {
            href: "/",
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
              alt: "Twilio, Inc."
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navbar/* Content */.VY, {
            role: "menubar",
            children: navLinks.map(function (link) {
              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                role: "none",
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkButton, {
                  link: link
                })
              }, link.id);
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navbar/* Aside */.xN, {
            children: aside
          })]
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Media/* default */.Z, {
      lessThan: "lg",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileNavigation/* default */.ZP, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MobileNavigation/* Navbar */.wp, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileNavigation_Navbar/* Brand */.H2, {
            href: "/",
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
              alt: "Twilio, Inc."
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileNavigation_Navbar/* Button */.zx, {
            onClick: function onClick() {
              return setIsMenuOpen(!isMenuOpen);
            },
            "aria-label": "Open menu",
            "aria-haspopup": "true",
            "aria-expanded": isMenuOpen,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* MenuIcon */.Oq, {
              color: theme.palette.neutrals.white[100]
            })
          })]
        })
      }), isMenuOpen && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledMobileNavMenu, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MobileNavigation/* Navbar */.wp, {
          tokens: {
            backgroundColor: theme.palette.twilio.gray[100]
          },
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileNavigation_Navbar/* Brand */.H2, {
            href: "/",
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
              alt: "Twilio, Inc."
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileNavigation_Navbar/* Button */.zx, {
            onClick: function onClick() {
              return setIsMenuOpen(!isMenuOpen);
            },
            "aria-label": "Close menu",
            "aria-haspopup": "true",
            "aria-expanded": isMenuOpen,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* CloseIcon */.Tw, {
              color: theme.palette.neutrals.white[100]
            })
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileNavigation/* Content */.VY, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Content, {
            role: "menubar",
            children: navLinks.map(function (link) {
              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                role: "none",
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkButton, {
                  link: link
                }, link.id)
              }, link.id);
            })
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileNavigation/* Footer */.$_, {
          children: aside
        })]
      })]
    })]
  });
};

var useActiveLink = function useActiveLink(url) {
  var _useRouter = (0,router.useRouter)(),
      pathname = _useRouter.pathname;

  return url.endsWith(pathname) || url.endsWith("".concat(pathname, "/"));
};

var LinkButton = /*#__PURE__*/(0,react.forwardRef)(function (_ref2, ref) {
  var link = _ref2.link;
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var isActive = useActiveLink(link.url);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
    hover: isActive,
    ref: ref,
    size: "small",
    variant: "primary",
    role: "menuitem",
    href: (0,getAbsoluteUrl/* default */.Z)(link.url, pageConfig),
    children: link.title
  });
});

var RegisterButton = function RegisterButton() {
  var registerLink = (0,useDomainPath/* default */.Z)("register");
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
    href: registerLink,
    color: "primary",
    variant: "filled",
    size: "medium",
    children: "Watch on-demand"
  });
};

var Content = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("ul",  true ? {
  target: "e9xrw8i1"
} : 0)( true ? {
  name: "lf9urh",
  styles: "display:flex;flex-direction:column;gap:20px;align-items:center;padding:40px 16px"
} : 0);

var StyledMobileNavMenu = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(MobileNavigation/* Menu */.v2,  true ? {
  target: "e9xrw8i0"
} : 0)("background:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.twilio.gray[100];
}, ";" + ( true ? "" : 0));

/* harmony default export */ var Navigation = (BaseNavigation);

/***/ }),

/***/ 95464:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SaveYourSpot_SaveYourSpot; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(81333);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/utils/useInView/index.ts + 1 modules
var useInView = __webpack_require__(85807);
// EXTERNAL MODULE: ../../libs/utils/useLottie/useLottie.tsx
var useLottie = __webpack_require__(73849);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ./src/views/CdpWeek2023/utils/useDomainPath/useDomainPath.ts
var useDomainPath = __webpack_require__(5565);
;// CONCATENATED MODULE: ./src/views/CdpWeek2023/components/SaveYourSpot/assets/cpd_week_lottie_footer.json.data
/* harmony default export */ var cpd_week_lottie_footer_json = ("/_next/static/data/cpd_week_lottie_footer.json-2240940acc16ff2558a8d6c4275034a9.json");
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/CdpWeek2023/components/SaveYourSpot/SaveYourSpot.tsx



function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }













var copy = {
  heading: "Tune into CDP Week 2023 today"
};
var BUTTON_TEXT = "Watch on-demand";

var SaveYourSpot = function SaveYourSpot() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();

  var _useState = (0,react.useState)(),
      animationData = _useState[0],
      setAnimationData = _useState[1];

  var registerLink = (0,useDomainPath/* default */.Z)("register");

  var _useLottie = (0,useLottie/* default */.Z)({
    options: {
      animationData: animationData,
      autoplay: true,
      loop: false
    }
  }),
      _useLottie2 = (0,slicedToArray/* default */.Z)(_useLottie, 2),
      animation = _useLottie2[0],
      containerRef = _useLottie2[1];

  (0,react.useEffect)(function () {
    setAnimationData(fetch(cpd_week_lottie_footer_json));
  }, []);
  var isInView = (0,useInView/* default */.Z)(containerRef);
  (0,react.useEffect)(function () {
    if (isInView && animation) {
      if (animation !== null && animation !== void 0 && animation.isPaused) {
        animation === null || animation === void 0 ? void 0 : animation.playSegments([0, animation.totalFrames], true);
        animation.addEventListener("enterFrame", function () {
          if (animation.currentFrame >= 59) {
            animation === null || animation === void 0 ? void 0 : animation.playSegments([60, animation.totalFrames], false);
          }
        });
      }
    } else {
      animation === null || animation === void 0 ? void 0 : animation.stop();
    }
  }, [animation, isInView]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Gradient, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledSection, {
      variant: "centered",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* default */.ZP, {
          centered: true,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            tag: "h2",
            children: copy.heading
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonWrapper, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
            variant: "filled",
            color: "primary",
            size: "large",
            href: (0,getAbsoluteUrl/* default */.Z)(registerLink, pageConfig),
            children: BUTTON_TEXT
          })
        })
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Animation, {
      ref: containerRef
    })]
  });
};

var Animation = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1an0pb93"
} : 0)( true ? "" : 0);

var Gradient = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1an0pb92"
} : 0)("background:linear-gradient(0deg, rgba(0, 0, 0, 0.24) 0%, rgba(0, 0, 0, 0.24) 100%),", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.cdpWeek2023.gray[100];
}, ";" + ( true ? "" : 0));

var StyledSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1an0pb91"
} : 0)(Section/* Wrapper */.im, "{row-gap:40px;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("lg");
}, "{row-gap:48px;}}" + ( true ? "" : 0));

var ButtonWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1an0pb90"
} : 0)( true ? {
  name: "k2urx9",
  styles: "display:grid;place-items:center;width:100%;margin:0 auto"
} : 0);

/* harmony default export */ var SaveYourSpot_SaveYourSpot = (SaveYourSpot);

/***/ }),

/***/ 5565:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


var useDomainPath = function useDomainPath() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(""),
      path = _useState[0],
      setPath = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var knownDomains = /^(http:\/\/|https:\/\/)?([a-zA-Z0-9]+.)?segment.(build|com)(\/.*)?$/i;
    var cleanPath = url ? "/".concat(url) : "";

    if (location.host.startsWith("localhost") || knownDomains.test(location.host)) {
      cleanPath = "/cdp-week-2023".concat(cleanPath, "/");
    }

    setPath(cleanPath);
  }, []);
  return path;
};

/* harmony default export */ __webpack_exports__["Z"] = (useDomainPath);

/***/ }),

/***/ 9746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var moment_timezone__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54764);
/* harmony import */ var moment_timezone__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment_timezone__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);


var FULL_FORMAT = "MMM. DD, hh:mma z";

var useLocalDate = function useLocalDate(date) {
  var tz = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "America/Los_Angeles";
  return (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    if (!date) {
      return "";
    }

    var localTimeZone = new Intl.DateTimeFormat().resolvedOptions().timeZone;
    var inputDateTime = moment_timezone__WEBPACK_IMPORTED_MODULE_0___default().tz(date, tz);
    var localDateTime = inputDateTime.clone().tz(localTimeZone);
    return localDateTime.format(FULL_FORMAT);
  }, [date]);
};

/* harmony default export */ __webpack_exports__["Z"] = (useLocalDate);

/***/ }),

/***/ 70171:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "me": function() { return /* reexport */ useAgendaQuery; },
  "lI": function() { return /* reexport */ useCdpWeekSpeakerLandingPageQuery; },
  "p7": function() { return /* reexport */ useSpeakersQuery; }
});

// UNUSED EXPORTS: createCdpWeekAgendaPageQuery, createCdpWeekSpeakerLandingPageQuery, createCdpWeekSpeakerQuery

// EXTERNAL MODULE: ../../libs/utils/createQueryHook/createQueryHook.ts
var createQueryHook = __webpack_require__(74048);
// EXTERNAL MODULE: ../../libs/contexts/staticSiteBackend.ts
var staticSiteBackend = __webpack_require__(86708);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(12741);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(20406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(28526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(81333);
// EXTERNAL MODULE: ../../node_modules/lodash/has.js
var has = __webpack_require__(93352);
var has_default = /*#__PURE__*/__webpack_require__.n(has);
;// CONCATENATED MODULE: ../../libs/api/utils/transformContentfulResponse.ts




function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var isAsset = function isAsset(entry) {
  return typeof entry === "object" && entry !== null && has_default()(entry, "fields.file");
};

var isEntry = function isEntry(entry) {
  return typeof entry === "object" && entry !== null && "fields" in entry;
};

var transformContentfulResponse = function transformContentfulResponse(data) {
  return Object.entries(data).reduce(function (acc, _ref) {
    var _ref2 = (0,slicedToArray/* default */.Z)(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    if (isAsset(value)) {
      var _value$fields, _value$fields2, _value$fields3, _value$fields3$file$d, _value$fields4, _value$fields4$file$d;

      return _objectSpread(_objectSpread({}, acc), {}, (0,defineProperty/* default */.Z)({}, key, {
        title: (_value$fields = value.fields) === null || _value$fields === void 0 ? void 0 : _value$fields.title,
        src: (_value$fields2 = value.fields) === null || _value$fields2 === void 0 ? void 0 : _value$fields2.file.url,
        width: (_value$fields3 = value.fields) === null || _value$fields3 === void 0 ? void 0 : (_value$fields3$file$d = _value$fields3.file.details.image) === null || _value$fields3$file$d === void 0 ? void 0 : _value$fields3$file$d.width,
        height: (_value$fields4 = value.fields) === null || _value$fields4 === void 0 ? void 0 : (_value$fields4$file$d = _value$fields4.file.details.image) === null || _value$fields4$file$d === void 0 ? void 0 : _value$fields4$file$d.height
      }));
    }

    if (isEntry(value)) {
      return _objectSpread(_objectSpread({}, acc), {}, (0,defineProperty/* default */.Z)({}, key, transformContentfulResponse(value.fields)));
    }

    if (Array.isArray(value)) {
      return _objectSpread(_objectSpread({}, acc), {}, (0,defineProperty/* default */.Z)({}, key, value.map(function (item) {
        if (isAsset(item)) {
          var _item$fields, _item$fields2, _item$fields3, _item$fields3$file$de, _item$fields4, _item$fields4$file$de;

          return {
            title: (_item$fields = item.fields) === null || _item$fields === void 0 ? void 0 : _item$fields.title,
            src: (_item$fields2 = item.fields) === null || _item$fields2 === void 0 ? void 0 : _item$fields2.file.url,
            width: (_item$fields3 = item.fields) === null || _item$fields3 === void 0 ? void 0 : (_item$fields3$file$de = _item$fields3.file.details.image) === null || _item$fields3$file$de === void 0 ? void 0 : _item$fields3$file$de.width,
            height: (_item$fields4 = item.fields) === null || _item$fields4 === void 0 ? void 0 : (_item$fields4$file$de = _item$fields4.file.details.image) === null || _item$fields4$file$de === void 0 ? void 0 : _item$fields4$file$de.height
          };
        }

        if (isEntry(item)) {
          return transformContentfulResponse(item.fields);
        }

        return item;
      })));
    }

    return _objectSpread(_objectSpread({}, acc), {}, (0,defineProperty/* default */.Z)({}, key, value));
  }, {});
};

/* harmony default export */ var utils_transformContentfulResponse = (transformContentfulResponse);
;// CONCATENATED MODULE: ../../libs/api/staticSiteBackend/cdpWeek2023.ts





function cdpWeek2023_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function cdpWeek2023_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? cdpWeek2023_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : cdpWeek2023_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}


var fetchCdpWeekSpeakerLandingPage = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(client, speakersLimit, options) {
    var response;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return client.get("/content/filter/cdpWeekSpeakerSessions?featured=true&limit=".concat(speakersLimit), options);

          case 2:
            response = _context.sent;
            return _context.abrupt("return", response.items.map(function (record) {
              var _record$speakerHeadsh, _record$speakerHeadsh2, _record$speakerHeadsh3;

              return cdpWeek2023_objectSpread(cdpWeek2023_objectSpread({}, record), {}, {
                speakerHeadshot: {
                  src: (_record$speakerHeadsh = record.speakerHeadshot) === null || _record$speakerHeadsh === void 0 ? void 0 : (_record$speakerHeadsh2 = _record$speakerHeadsh.file) === null || _record$speakerHeadsh2 === void 0 ? void 0 : _record$speakerHeadsh2.url,
                  title: (_record$speakerHeadsh3 = record.speakerHeadshot) === null || _record$speakerHeadsh3 === void 0 ? void 0 : _record$speakerHeadsh3.title
                }
              });
            }));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchCdpWeekSpeakerLandingPage(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
var fetchCdpWeekAgendaPage = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(client, options) {
    var res, response, data;
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return client.get("/content/entries/cdpWeekAgendaItem", options);

          case 2:
            res = _context2.sent;
            response = res.map(function (item) {
              return cdpWeek2023_objectSpread(cdpWeek2023_objectSpread({}, item), {}, {
                speaker: item.speaker.map(function (speaker) {
                  var _speaker$fields$speak, _speaker$fields$speak2, _speaker$fields$speak3, _speaker$fields$speak4, _speaker$fields$speak5;

                  return cdpWeek2023_objectSpread(cdpWeek2023_objectSpread({}, speaker.fields), {}, {
                    speakerHeadshot: {
                      src: (_speaker$fields$speak = speaker.fields.speakerHeadshot) === null || _speaker$fields$speak === void 0 ? void 0 : (_speaker$fields$speak2 = _speaker$fields$speak.fields) === null || _speaker$fields$speak2 === void 0 ? void 0 : (_speaker$fields$speak3 = _speaker$fields$speak2.file) === null || _speaker$fields$speak3 === void 0 ? void 0 : _speaker$fields$speak3.url,
                      title: (_speaker$fields$speak4 = speaker.fields.speakerHeadshot) === null || _speaker$fields$speak4 === void 0 ? void 0 : (_speaker$fields$speak5 = _speaker$fields$speak4.fields) === null || _speaker$fields$speak5 === void 0 ? void 0 : _speaker$fields$speak5.title
                    }
                  });
                })
              });
            });
            data = {
              featured: response.filter(function (item) {
                return item.featuredSession;
              })[0],
              items: response
            };
            return _context2.abrupt("return", utils_transformContentfulResponse(cdpWeek2023_objectSpread({}, data)));

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchCdpWeekAgendaPage(_x4, _x5) {
    return _ref2.apply(this, arguments);
  };
}();
var fetchCdpWeekSpeakerPage = /*#__PURE__*/function () {
  var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(client, options) {
    var response, speakersOrder, landingPageSpeakers, finalResponse;
    return regenerator_default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return client.get("/content/filter/cdpWeekSpeakerSessions", options);

          case 2:
            response = _context3.sent;
            _context3.next = 5;
            return client.get("/content/entries/cdpWeekSpeakerLandingPage");

          case 5:
            speakersOrder = _context3.sent;
            landingPageSpeakers = speakersOrder[0].speakerOrder.map(function (e) {
              return e.fields;
            });
            finalResponse = landingPageSpeakers.reduce(function (acc, landingPageSpeaker) {
              var sessionSpeaker = response.items.find(function (e) {
                return e.speakerName === landingPageSpeaker.speakerName;
              });

              if (!sessionSpeaker) {
                var _landingPageSpeaker$s;

                landingPageSpeaker.sessions = [{
                  sessionTitle: "",
                  featuredSession: false,
                  sessionDescription: "",
                  shortDescription: "",
                  sessionDateTimePdt: ""
                }];
                landingPageSpeaker.speakerHeadshot = (_landingPageSpeaker$s = landingPageSpeaker.speakerHeadshot) === null || _landingPageSpeaker$s === void 0 ? void 0 : _landingPageSpeaker$s.fields;
                return {
                  items: [].concat((0,toConsumableArray/* default */.Z)(acc.items), [landingPageSpeaker])
                };
              }

              return {
                items: [].concat((0,toConsumableArray/* default */.Z)(acc.items), [sessionSpeaker])
              };
            }, {
              items: []
            });
            return _context3.abrupt("return", finalResponse.items.map(function (record) {
              var _record$speakerHeadsh4, _record$speakerHeadsh5, _record$speakerHeadsh6;

              return cdpWeek2023_objectSpread(cdpWeek2023_objectSpread({}, record), {}, {
                speakerHeadshot: {
                  src: (_record$speakerHeadsh4 = record.speakerHeadshot) === null || _record$speakerHeadsh4 === void 0 ? void 0 : (_record$speakerHeadsh5 = _record$speakerHeadsh4.file) === null || _record$speakerHeadsh5 === void 0 ? void 0 : _record$speakerHeadsh5.url,
                  title: (_record$speakerHeadsh6 = record.speakerHeadshot) === null || _record$speakerHeadsh6 === void 0 ? void 0 : _record$speakerHeadsh6.title
                }
              });
            }));

          case 9:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function fetchCdpWeekSpeakerPage(_x6, _x7) {
    return _ref3.apply(this, arguments);
  };
}();
;// CONCATENATED MODULE: ../../libs/api/routes/cdpWeek2023/queries/cdpWeekSpeakerAgendaPageQuery.ts



var createCdpWeekAgendaPageQuery = function createCdpWeekAgendaPageQuery(client) {
  return [["cdpWeek2023", "AgendaPage"], function () {
    return fetchCdpWeekAgendaPage(client);
  }];
};
var useAgendaQuery = (0,createQueryHook/* default */.Z)(createCdpWeekAgendaPageQuery, staticSiteBackend/* useStaticSiteBackend */.gR, {
  staleTime: Infinity
});
;// CONCATENATED MODULE: ../../libs/api/routes/cdpWeek2023/queries/cdpWeekSpeakerLandingPageQuery.ts



var createCdpWeekSpeakerLandingPageQuery = function createCdpWeekSpeakerLandingPageQuery(client, _ref) {
  var speakersLimit = _ref.speakersLimit;
  return [["cdpWeek2023", "LandingPage"], function () {
    return fetchCdpWeekSpeakerLandingPage(client, speakersLimit);
  }];
};
var useCdpWeekSpeakerLandingPageQuery = (0,createQueryHook/* default */.Z)(createCdpWeekSpeakerLandingPageQuery, staticSiteBackend/* useStaticSiteBackend */.gR, {
  staleTime: Infinity
});
;// CONCATENATED MODULE: ../../libs/api/routes/cdpWeek2023/queries/cdpWeekSpeakerQuery.ts



var createCdpWeekSpeakerQuery = function createCdpWeekSpeakerQuery(client) {
  return [["cdpWeek2023", "SpeakerPage"], function () {
    return fetchCdpWeekSpeakerPage(client);
  }];
};
var useSpeakersQuery = (0,createQueryHook/* default */.Z)(createCdpWeekSpeakerQuery, staticSiteBackend/* useStaticSiteBackend */.gR, {
  staleTime: Infinity
});
;// CONCATENATED MODULE: ../../libs/api/routes/cdpWeek2023/queries/index.ts




/***/ }),

/***/ 86708:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D1": function() { return /* binding */ StaticSiteBackendProvider; },
/* harmony export */   "I4": function() { return /* binding */ createStaticSiteBackend; },
/* harmony export */   "gR": function() { return /* binding */ useStaticSiteBackend; }
/* harmony export */ });
/* unused harmony export StaticSiteBackendContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _segment_api_staticSiteBackend_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39896);


var StaticSiteBackendContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
var StaticSiteBackendProvider = StaticSiteBackendContext.Provider;
var useStaticSiteBackend = function useStaticSiteBackend() {
  var staticSiteBackend = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(StaticSiteBackendContext);

  if (!staticSiteBackend) {
    throw new Error("Static site backend isn't available. Please set it via StaticSiteBackendProvider component.");
  }

  return staticSiteBackend;
}; // Helper method to simplify importing

var createStaticSiteBackend = function createStaticSiteBackend() {
  return (0,_segment_api_staticSiteBackend_client__WEBPACK_IMPORTED_MODULE_1__/* .createClient */ .e)();
};

/***/ }),

/***/ 33445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Button__WEBPACK_IMPORTED_MODULE_0__.z; },
/* harmony export */   "l": function() { return /* reexport safe */ _Button__WEBPACK_IMPORTED_MODULE_0__.l; }
/* harmony export */ });
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62073);


/***/ }),

/***/ 95290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82269);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81333);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27866);



var _excluded = ["onClick"],
    _excluded2 = ["onClick"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}



var DEFAULT_OPTIONS = {
  closeOnOverlayClick: true
};
var DEFAULT_EVENTS = ["mousedown", "touchstart"];

var useModal = function useModal(menuRef, _ref, options) {
  var _ref2 = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, 2),
      setOpened = _ref2[1];

  var settings = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    return _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), options);
  }, [options]);

  var getControlOpenProps = function getControlOpenProps() {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _onClick = _ref3.onClick,
        rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref3, _excluded);

    return _objectSpread({
      onClick: function onClick(event) {
        setOpened(true);
        _onClick === null || _onClick === void 0 ? void 0 : _onClick(event);
      }
    }, rest);
  };

  var getControlCloseProps = function getControlCloseProps() {
    var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _onClick2 = _ref4.onClick,
        rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref4, _excluded2);

    return _objectSpread({
      'aria-label': "Close the modal",
      onClick: function onClick(event) {
        setOpened(false);
        _onClick2 === null || _onClick2 === void 0 ? void 0 : _onClick2(event);
      }
    }, rest);
  };

  (0,react_use__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(menuRef, function () {
    if (settings.closeOnOverlayClick) {
      setOpened(false);
    }
  }, settings.closeOnOverlayClick ? DEFAULT_EVENTS : []);
  return {
    getControlOpenProps: getControlOpenProps,
    getControlCloseProps: getControlCloseProps
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (useModal);

/***/ }),

/***/ 16164:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Paper_Paper; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/matcha/components/Paper/Paper.views.tsx

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "etxif140"
} : 0)("background:", function (_ref) {
  var background = _ref.background;
  return background;
}, ";border-radius:", function (_ref2) {
  var borderRadius = _ref2.borderRadius;
  return borderRadius;
}, "px;border:", function (_ref3) {
  var border = _ref3.border;
  return border;
}, ";width:100%;height:100%;box-shadow:", function (_ref4) {
  var theme = _ref4.theme,
      elevation = _ref4.elevation;
  return theme.shadows[elevation];
}, ";" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/components/Paper/Paper.tsx


var _excluded = ["background", "borderRadius", "border", "elevation", "children"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var Paper = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var background = _ref.background,
      _ref$borderRadius = _ref.borderRadius,
      borderRadius = _ref$borderRadius === void 0 ? 10 : _ref$borderRadius,
      _ref$border = _ref.border,
      border = _ref$border === void 0 ? "none" : _ref$border,
      _ref$elevation = _ref.elevation,
      elevation = _ref$elevation === void 0 ? 0 : _ref$elevation,
      children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, _objectSpread(_objectSpread({
    background: background || theme.palette.brand.boysenberry[100],
    borderRadius: borderRadius,
    border: border,
    elevation: elevation,
    ref: ref
  }, rest), {}, {
    children: children
  }));
});
/* harmony default export */ var Paper_Paper = (Paper);
;// CONCATENATED MODULE: ../../libs/matcha/components/Paper/index.ts


/***/ }),

/***/ 32151:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* reexport safe */ _FontContext__WEBPACK_IMPORTED_MODULE_0__.jv; }
/* harmony export */ });
/* harmony import */ var _FontContext__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93052);


/***/ }),

/***/ 74048:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12741);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58943);



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}


/**
 * Creates query hook from query factory
 *
 * @param fetchFactory factory function creating [query key, fetchFunction] tuple for use with react-query lib
 * @param useClientInstance hook function returning client instance to use with fetching function
 * @returns hook function wrapping useQuery
 */

var createQueryHook = function createQueryHook(fetchFactory, useClientInstance, defaultOptions) {
  return function (_ref) {
    var args = _ref.args,
        options = _ref.options;
    var instance = useClientInstance();
    return _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery.apply */ .a.apply(void 0, (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(fetchFactory.apply(void 0, [instance].concat((0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(args)))).concat([_objectSpread(_objectSpread({}, defaultOptions), options)]));
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (createQueryHook);

/***/ }),

/***/ 85807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useInView; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/utils/useInView/useInView.ts

/**
 * A hook to observe elements in the viewport
 * @param ref - A ref to the element to observe
 * @param options - The options for the IntersectionObserver
 * @returns A boolean indicating if the element is in the viewport
 */

var useIsInView = function useIsInView(ref) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$stopOnIntersecti = _ref.stopOnIntersection,
      stopOnIntersection = _ref$stopOnIntersecti === void 0 ? true : _ref$stopOnIntersecti,
      options = _ref.options;

  var _useState = (0,react.useState)(false),
      isInView = _useState[0],
      setIsInView = _useState[1];

  var inViewRef = (0,react.useRef)(false);
  (0,react.useEffect)(function () {
    var intersectionObserver = new IntersectionObserver(function (intersection) {
      if (intersection.some(function (i) {
        return i.isIntersecting;
      })) {
        inViewRef.current = true;
        setIsInView(true);

        if (stopOnIntersection) {
          intersectionObserver.disconnect();
        }
      } else if (inViewRef.current) {
        inViewRef.current = false;
        setIsInView(false);
      }
    }, options);

    if (ref.current) {
      intersectionObserver.observe(ref.current);
    }

    return function () {
      intersectionObserver.disconnect();
    };
  }, [ref]);
  return isInView;
};

/* harmony default export */ var useInView = (useIsInView);
;// CONCATENATED MODULE: ../../libs/utils/useInView/index.ts


/***/ }),

/***/ 73849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var lottie_web__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12039);
/* harmony import */ var lottie_web__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lottie_web__WEBPACK_IMPORTED_MODULE_2__);


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}



/**
 * A hook that provides an animation instance and a ref to the container element.
 * @param options The options to configure the animation.
 * @returns The animation instance and a ref to the container element.
 */

var useLottie = function useLottie(_ref) {
  var options = _ref.options;
  var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null),
      animationInstance = _useState[0],
      setAnimationInstance = _useState[1];

  var initializedRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(false);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (!containerRef || !options.animationData || initializedRef.current) {
      return;
    }

    initializedRef.current = true;
    options.animationData.then(function (response) {
      return typeof response.json === "function" ? response.json() : response;
    }).then(function (data) {
      setAnimationInstance(lottie_web__WEBPACK_IMPORTED_MODULE_2___default().loadAnimation(_objectSpread(_objectSpread({
        container: containerRef.current
      }, options), {}, {
        animationData: data
      })));
    });
    return function () {
      return animationInstance === null || animationInstance === void 0 ? void 0 : animationInstance.destroy();
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [containerRef, options.animationData]);
  return [animationInstance, containerRef];
};

/* harmony default export */ __webpack_exports__["Z"] = (useLottie);

/***/ }),

/***/ 26880:
/***/ (function(module) {

module.exports = "/_next/static/images/OgImageCDPWeek2023-b8acc6cdb3fcbfc94d82f7a4739d0fd7.png";

/***/ })

}]);